import { create } from 'zustand';

export type PositionType = 'default' | 'tab' | 'drawer' | 'drawer-lg' | 'drawer-sm' | 'map-toolbar';
export type PositionInput = PositionType | number;

export const POSITION_VALUES: Record<PositionType, { x: number; y: number }> = {
  default: { x: 10, y: 10 },
  tab: { x: 450, y: 10 },
  drawer: { x: 580, y: 10 },
  'drawer-sm': { x: 460, y: 10 },
  'drawer-lg': { x: 740, y: 10 },
  'map-toolbar': { x: 680, y: 80 },
};

export const POSITION_TRANSITION = 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)';

export const FOOTER_VISIBLE_BOTTOM = 76;

interface ChatWidgetPositionState {
  position: PositionInput;
  isFooterVisible: boolean;
  setPosition: (position: PositionInput) => void;
  setFooterVisible: (visible: boolean) => void;
}

export const useChatWidgetPositionStore = create<ChatWidgetPositionState>((set) => ({
  position: 'default',
  isFooterVisible: false,
  setPosition: (position) => set({ position }),
  setFooterVisible: (isFooterVisible) => set({ isFooterVisible }),
}));

export const computePositionRect = (position: PositionInput, isFooterVisible: boolean) => {
  let x: number;
  let y = 10;
  let skipFooterOverride = false;

  if (typeof position === 'number') {
    x = position;
  } else {
    ({ x, y } = POSITION_VALUES[position]);
    skipFooterOverride = position === 'drawer' || position === 'drawer-lg' || position === 'drawer-sm' || position === 'map-toolbar';
  }

  const bottom = isFooterVisible && !skipFooterOverride ? FOOTER_VISIBLE_BOTTOM : y;
  return { right: x, bottom };
};
